module.exports = __webpack_public_path__ + "img/1513142928.b68bc74d.jpg";